import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Form, Modal } from "react-bootstrap";
import { ButtonComponent } from "../elements";
import axios from "axios";
import { API_URL } from "../../constant/constant";
import PaginationComponent from "../PaginationComponent";

export default function DownPaymentTable() {
    const { t } = useContext(TranslatorContext);
    const [ServiceDetails, setServiceDetails] = useState([]);
    const [Error, setError] = useState('');
    const [EditDownpaymentError, setEditDownpaymentError] = useState({});
    const [modalShow, setModalShow] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 5;

    const indexOfLastEntry = currentPage * entriesPerPage;
    const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;

    const fetchServiceDetails = () => {
        const user_type = localStorage.getItem('user_type');
        axios.post(API_URL + "/fetch_downpayment", { user_type })
            .then((response) => {
                setServiceDetails(response.data.downpayment_arr || []);
            })
            .catch((error) => {
                console.error('Error fetching downpayment details:', error);
            });
    };

    useEffect(() => {
        fetchServiceDetails();
    }, []);

    const handleEditDownpayment = (index) => {
        let hasError = false;
        let errors = {};

        if (!ServiceDetails[index].downpayment_percentage) {
            errors[index] = (t("enter_downpayment_percentage"));
            hasError = true;
        }

        if (hasError) {
            setEditDownpaymentError(errors);
            return;
        }

        console.log(ServiceDetails[index].downpayment_percentage);

        axios.post(API_URL + '/edit_downpayment', {
            downpayment_id: ServiceDetails[index].downpayment_id,
            downpayment: ServiceDetails[index].downpayment_percentage
        })
            .then(response => {
                if (response.data.success) {
                    setModalShow(true);
                    setTimeout(() => {
                        setModalShow(false);
                    }, 1000);
                    fetchServiceDetails();
                }
                else {
                    setModalShow(true);
                    setTimeout(() => {
                        setModalShow(false);
                    }, 1000);
                }
            })
            .catch(error => {
                setModalShow(true);
                setTimeout(() => {
                    setModalShow(false);
                }, 1000);
                console.error('Error updating downpayment:', error);
            });
    };

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <>
            <div className="">
                {ServiceDetails.slice(indexOfFirstEntry, indexOfLastEntry).map((item, index) => (
                    <div className="row " key={index} style={{ marginBottom: '20px' }}>
                        <div className="col-lg-4">
                            <Form.Group className="form-group mb-4 ">
                                <Form.Label>{t('downpayment_percentage')}</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={item.downpayment_percentage || ''}
                                    placeholder={t('enter_downpayment_percentage')}
                                    onChange={(e) => {
                                        const updatedServiceDetails = [...ServiceDetails];
                                        updatedServiceDetails[index].downpayment_percentage = e.target.value;
                                        setServiceDetails(updatedServiceDetails);
                                        setEditDownpaymentError('')
                                    }}
                                />
                                {/* Display error if this field is empty */}
                                {EditDownpaymentError[index] && (
                                    <p style={{ color: 'red' }}>{EditDownpaymentError[index]}</p>
                                )}
                            </Form.Group>
                        </div>
                        <div className="col-lg-4">
                            <ButtonComponent
                                type="button"
                                className="btn btn-success " style={{ marginTop: '32px' }}
                                onClick={() => handleEditDownpayment(index)}  // Pass the index to handleEditDownpayment
                            >
                                {t('save_changes')}
                            </ButtonComponent>
                        </div>
                    </div>
                ))}

                <PaginationComponent
                    totalEntries={ServiceDetails.length}
                    entriesPerPage={entriesPerPage}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            </div>


            <Modal show={modalShow} onHide={() => setModalShow(false)} className="custom-modal">
                <Modal.Header closeButton className="border-0">
                    <Modal.Title className="w-100 text-center">
                        Update
                        <hr className="my-2" style={{ borderTop: '2px solid #007bff', width: '100%' }} />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <p className="lead mb-4">Downpayment Updated Successfully</p>
                </Modal.Body>
                <Modal.Footer className="border-0 justify-content-center">
                    {/* <button className="btn btn-primary px-4" onClick={() => setModalShow(false)}>
            Close
        </button> */}
                </Modal.Footer>
            </Modal>
        </>
    );
}
